import React from 'react';
import SelectComponent from 'shared/components/SelectComponent';

const StencilLengthSelect = (props) => {
  const name = 'stencil_length';

  const {
    label,
    onChangeParameter,
    parameters,
    required,
    options,
    tooltip,
    groupName,
    errorMessage,
  } = props;

  return (
    <SelectComponent
      label={label}
      name={name}
      onChange={(e) => onChangeParameter(name, e.target.value)}
      required={required}
      options={options}
      tooltip={tooltip}
      selected={parameters[name] || ''}
      groupName={groupName}
      errorMessage={errorMessage} />
  );
};

StencilLengthSelect.defaultProps = {
  options: [],
  label: Spree.translations.parameters.stencil_length,
  tooltip: Spree.helpForParameters.stencil_length,
};

export default StencilLengthSelect;
